export const languages = [
  { code: "en", name: "English" },
  { code: "ja", name: "日本語" },
]

